export default {
    'name': 'breadcrumbs',
    'width': '20',
    'height': '20',
    'viewBox': '0 0 20 20',
    'data': '<g opacity=\'0.8\'><path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M11.6712 15.2732L16.2545 10.3079C16.5374 10.0015 16.5374 9.52911 16.2545 9.22266L11.6712 4.25738C11.3715 3.93272 10.8654 3.91248 10.5407 4.21216C10.2161 4.51184 10.1958 5.01797 10.4955 5.34263L13.8716 9H3.1667C2.72487 9 2.3667 9.35818 2.3667 9.8C2.3667 10.2418 2.72487 10.6 3.1667 10.6H13.8075L10.4955 14.1879C10.1958 14.5126 10.2161 15.0187 10.5407 15.3184C10.8654 15.6181 11.3715 15.5978 11.6712 15.2732Z\' fill=\'#1D5344\'/></g>'
}
